import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ server, onRemove }) => {
    return (<tr>
        <td style={{ textAlign: 'left' }}>{server.name}</td>
        <td>{server.ip}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="danger" onClick={() => onRemove(server.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);

};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/Servers/components/Table/components/Row/index.js